import paths from "./pathways";
const { pathway1, pathway2, pathway3, pathway4, pathway5, pathway6, pathway7 } =
    paths;

export const data = {
    pathways: [
        {
            key: "0",
            name: "What is your highest level of education or credential?",
            goToResults: false,
            options: [
                {
                    name: "In Progress or Completed High School Diploma",
                    value: 1,
                },
                {
                    name: "In Progress or Partially Completed Undergraduate Degree",
                    value: 2,
                },
                {
                    name: "Completed Undergraduate Degree",
                    value: 3,
                },
                {
                    name: "Completed Post Secondary Diploma or Certificate",
                    value: 4,
                },
                {
                    name: "K-12 Teaching Certification",
                    value: 5,
                },
                {
                    name: "In Progress or Completed Master’s Degree",
                    value: 6,
                },
                {
                    name: "In Progress or Completed Doctoral Degree",
                    value: 7,
                },
            ],
        },
        ...pathway1,
        ...pathway2,
        ...pathway3,
        ...pathway4,
        ...pathway5,
        ...pathway6,
        ...pathway7,
    ],
};
